import { componentLabel, customComponentsCategory } from '../utils/editor';
import loadComponent from './component';
import imageLandscapeIcon from './icons/image-landscape.svg';

const defaultOptions = {
  componentType: 'Banner',
  componentName: 'Banner',
  category: customComponentsCategory,
};

function loadBlock(editor, options) {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel(options.componentName, imageLandscapeIcon),
    category: options.category,
    content: '<Banner />'
  });
}

export default function (editor, opts = {}) {
  const options = {...defaultOptions, ...opts};

  loadComponent(editor, options)
  loadBlock(editor, options);
}
